import { defineAsyncComponent } from 'vue';

const PARetroSalaryIncreasePopup = defineAsyncComponent(() =>
  import('@/views/salary/retroSalary/PARetroSalaryIncreasePopup.vue')
);
const PARetroStandardSalaryIncreasePopup = defineAsyncComponent(() =>
  import('@/views/salary/retroSalary/PARetroStandardSalaryIncreasePopup.vue')
);
const PARetroSalaryIncreaseDetail = defineAsyncComponent(() =>
  import('@/views/salary/retroSalary/PARetroSalaryIncreaseDetail.vue')
);
const PARetroStandardSalaryIncreaseDetail = defineAsyncComponent(() =>
  import('@/views/salary/retroSalary/PARetroStandardSalaryIncreaseDetail.vue'),
);
const chooseEmployeeForm = defineAsyncComponent(() =>
  import('@/views/salary/statisticalDayOff/ChooseEmployeeForm.vue')
);

const addPayrollPeriod = defineAsyncComponent(() => import('@/views/salary/salaryList/AddPayrollPeriod.vue'));
const salaryTemplateManage = defineAsyncComponent(() => import('@/views/salary/salaryList/SalaryTemplateManage.vue'));

const pASalaryDetail = defineAsyncComponent(() => import('@/views/salary/salaryList/PASalaryDetail.vue'));
// Đăng kí popup detail cho Bảng thu nhập không thường xuyên (vqphong - 17/10/2022)
const PAOtherIncomeDetail = defineAsyncComponent(() => import('@/views/salary/otherIncome/PAOtherIncomeDetail.vue'));

// form thông báo xóa lỗi
const DeleteSalaryErrorPopup = defineAsyncComponent(() =>
  import('@/views/salary/salaryList/DeleteSalaryErrorPopup.vue')
);
// Lấy dữ liệu trả lương
const pAPaySalaryGenDataPopup = defineAsyncComponent(() =>
  import('@/views/salary/pAPaySalary/PAPaySalaryGenDataPopup.vue')
);

//Chuyển khoản kho bạc trả lương
const BUTransferSalaryDetail = defineAsyncComponent(() =>
  import('@/views/salary/pAPaySalary/BUTransferSalaryDetail.vue')
);

const PAOtherOutcomeDetail = defineAsyncComponent(() =>
  import('@/views/salary/paotheroutcome/PAOtherOutcomeDetail.vue')
);

const PAWithdrawEstimate = defineAsyncComponent(() => import('@/views/salary/withdrawEstimate/PAWithdrawEstimate.vue'));

const PAWithdrawEstimateV2 = defineAsyncComponent(() => import('@/views/salary/withdrawEstimate/PAWithdrawEstimateV2.vue'));

const PAMappingSalagovBudgetSource = defineAsyncComponent(() =>
  import('@/views/salary/withdrawEstimate/PAMappingSalagovBudgetSource.vue')
);
// form phân bổ nguồn
const SalaryAllocation = defineAsyncComponent(() => import('@/views/salary/salaryAllocation/PASalaryAllocation.vue'));

// form Thiết lập mẫu bảng lương
const TemplateSetupSalary = defineAsyncComponent(() => import('@/views/salary/templateSetup/TemplateSetup.vue'));

// form Thêm cột mẫu bảng lương
const InsertColumnTemplate = defineAsyncComponent(() =>
  import('@/views/salary/templateSetup/InsertColumnTemplate.vue')
);

// Đăng kí popup nộp thuế TNCN (NHANH3 24.10.2022)
const PAPayTax = defineAsyncComponent(() => import('@/views/salary/pAPersonalIncomeTax/PAPayTax.vue'));

//Chi tiền gửi trả lương
const BAWithDrawSalaryDetail = defineAsyncComponent(() =>
  import('@/views/salary/pAPaySalary/BAWithDrawSalaryDetail.vue')
);

// Popup Phiếu chi trả lương
const CAPaymentSalaryDetail = defineAsyncComponent(() =>
  import('@/views/salary/pAPaySalary/CAPaymentSalaryDetail.vue')
);

//Popup tùy chọn sinh phiếu rút lương DVMINH 08/02/2023
const OptionsConnectSalagovPopup = defineAsyncComponent(() =>
  import('@/views/salary/optionsConnectSalagov/OptionsConnectSalagovPopup.vue')
);

// Thêm mới kỳ tính thuế
const PAPersonalIncomeTaxAddPopup = defineAsyncComponent(() =>
  import('@/views/salary/pAPersonalIncomeTax/PAPersonalIncomeTaxAddPopup.vue')
);

// Chi tiết ký tính thuế
const PAPersonalIncomeTaxDetail = defineAsyncComponent(() =>
  import('@/views/salary/pAPersonalIncomeTax/PAPersonalIncomeTaxDetail.vue')
);

// Cập nhật thuế vào bảng lương
const PAPersonalIncomeTaxUpdateSalaryPopup = defineAsyncComponent(() =>
  import('@/views/salary/pAPersonalIncomeTax/PAPersonalIncomeTaxUpdateSalaryPopup.vue')
);

//Sắp xếp cán bộ
const pASortEmployee = defineAsyncComponent(() => import('@/views/salary/pASortEmployee/PASortEmployee.vue'));

const ChooseExpenseSalaryPopup = defineAsyncComponent(() =>
  import('@/views/salary/gLPayrollExpenseSalary/ChooseExpenseSalaryPopup.vue')
);

const GLPayrollExpenseDetail = defineAsyncComponent(() =>
  import('@/views/salary/gLPayrollExpenseSalary/GLPayrollExpenseDetail.vue')
);

//Nộp bảo hiểm, công đoàn phí
const PAPayUnionInsuranceGenDataPopup = defineAsyncComponent(() =>
  import('@/views/salary/pAPayUnionInsurance/PAPayUnionInsuranceGenDataPopup.vue')
);

//Nộp bảo hiểm, công đoàn phí
const PaySalaryInsuranceSalagovPopup = defineAsyncComponent(() =>
  import('@/views/salary/salarySalagov/paySalaryInsuranceSalagov/PaySalaryInsuranceSalagovPopup.vue')
);

const PAWithdrawSalagovResult = defineAsyncComponent(() =>
  import('@/views/salary/withdrawEstimate/PAWithDrawSalagovResult.vue')
);
const PASalaryQuickSearch = defineAsyncComponent(() =>
  import('@/views/salary/salaryList/PASalaryQuickSearch.vue')
);

// Gửi email thông báo trả lương cho cán bộ nhân viên (20.05.2024)
const NotifySalaryPayment = defineAsyncComponent(() => import('@/views/salary/salaryList/NotifySalaryPayment.vue'))

export function registerPA(app) {
  app.component('AddPayrollPeriod', addPayrollPeriod);
  app.component('SalaryTemplateManage', salaryTemplateManage);
  app.component('PASalaryDetail', pASalaryDetail);
  app.component('pAPaySalaryGenDataPopup', pAPaySalaryGenDataPopup);
  app.component('BUTransferSalaryDetail', BUTransferSalaryDetail);
  app.component('BAWithDrawSalaryDetail', BAWithDrawSalaryDetail);
  app.component('CAPaymentSalaryDetail', CAPaymentSalaryDetail);

  app.component('ChooseEmployeeForm', chooseEmployeeForm);
  app.component('PAOtherOutcomeDetail', PAOtherOutcomeDetail);
  app.component('PAWithdrawEstimate', PAWithdrawEstimate);
  app.component('PAWithdrawEstimateV2', PAWithdrawEstimateV2);
  app.component('PAMappingSalagovBudgetSource', PAMappingSalagovBudgetSource);
  app.component('DeleteSalaryErrorPopup', DeleteSalaryErrorPopup);
  app.component('SalaryAllocation', SalaryAllocation);
  app.component('TemplateSetupSalary', TemplateSetupSalary);
  app.component('InsertColumnTemplate', InsertColumnTemplate);
  app.component('PARetroSalaryIncreasePopup', PARetroSalaryIncreasePopup);
  app.component('PARetroStandardSalaryIncreasePopup', PARetroStandardSalaryIncreasePopup);
  app.component('PARetroSalaryIncreaseDetail', PARetroSalaryIncreaseDetail);
  app.component('PARetroStandardSalaryIncreaseDetail', PARetroStandardSalaryIncreaseDetail);
  app.component('PAPayTax', PAPayTax);
  app.component('PAOtherIncomeDetail', PAOtherIncomeDetail);
  app.component('PAPersonalIncomeTaxAddPopup', PAPersonalIncomeTaxAddPopup);
  app.component('PAPersonalIncomeTaxDetail', PAPersonalIncomeTaxDetail);
  app.component('PAPersonalIncomeTaxUpdateSalaryPopup', PAPersonalIncomeTaxUpdateSalaryPopup);
  app.component('ChooseExpenseSalaryPopup', ChooseExpenseSalaryPopup);
  app.component('GLPayrollExpenseDetail', GLPayrollExpenseDetail);
  app.component('PAPayUnionInsuranceGenDataPopup', PAPayUnionInsuranceGenDataPopup);
  app.component('PaySalaryInsuranceSalagovPopup', PaySalaryInsuranceSalagovPopup);
  app.component('PASortEmployee', pASortEmployee);
  app.component('OptionsConnectSalagovPopup', OptionsConnectSalagovPopup);
  app.component('PAWithdrawSalagovResult', PAWithdrawSalagovResult);
  app.component('PASalaryQuickSearch', PASalaryQuickSearch);
  app.component('NotifySalaryPayment', NotifySalaryPayment);
}
